import { render, staticRenderFns } from "./PostReactionGraph.vue?vue&type=template&id=31a35716&scoped=true&"
import script from "./PostReactionGraph.vue?vue&type=script&lang=js&"
export * from "./PostReactionGraph.vue?vue&type=script&lang=js&"
import style0 from "./PostReactionGraph.vue?vue&type=style&index=0&id=31a35716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a35716",
  null
  
)

export default component.exports